// extracted by mini-css-extract-plugin
export default {"about-us-container":"AboutUs_about-us-container__pKHgb","founder-sections":"AboutUs_founder-sections__Hsg39"};